export default __webpack_public_path__ + "static/media/nav-logo-white.6e5ca7d5.png";